import React from 'react';
import Wrapper from '@interness/web-core/src/components/structure/Wrapper/Wrapper';
import Center from '@interness/web-core/src/components/structure/Center/Center';
import Spacer from '@interness/web-core/src/components/structure/Spacer/Spacer';
import { jsx as ___EmotionJSX } from "@emotion/react";
const MaintenanceModePage = () => {
  return ___EmotionJSX(Wrapper, null, ___EmotionJSX(Spacer, null), ___EmotionJSX(Center, null, ___EmotionJSX("h1", null, "Wir sind gleich zur\xFCck..."), ___EmotionJSX("p", null, "Wir aktualisieren gerade unseren Shop. ", ___EmotionJSX("br", null), "Bitte versuchen Sie es sp\xE4ter erneut.")), ___EmotionJSX(Spacer, null));
};
export default MaintenanceModePage;